import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  initializeKeycloak,
  ClientDetailsInterceptor,
  SatHeaderInterceptor,
  MockedKeycloakService,
  UiModule,
} from '@irembo-andela/irembogov3-common';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServicesModule } from './modules/services/services.module';
import { UsersModule } from './modules/users/users.module';
import { ReportingModule } from './modules/reporting/reporting.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ServiceManagementPortalHomeComponent } from './components/service-management-portal-home/service-management-portal-home.component';
import { RoleBasedRedirectComponent } from './components/role-based-redirect/role-based-redirect.component';
import { AddHeaderInterceptor } from './core/interceptors/add-header-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from './modules/shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ServiceManagementPortalHomeComponent,
    RoleBasedRedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KeycloakAngularModule,
    HttpClientModule,
    UiModule,
    NgbModule,
    ServicesModule,
    UsersModule,
    ReportingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      defaultLanguage:
        localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  providers: [
    {
      provide: 'environment',
      useValue: environment,
    },
    {
      provide: KeycloakService,
      useClass: environment.enableKeycloakMockService
        ? MockedKeycloakService
        : KeycloakService,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloakService: KeycloakService) => {
        return initializeKeycloak(keycloakService, {
          url: environment.authServiceUrl,
          realm: environment.authRealm,
          clientId: environment.authClientId,
          redirectUri: environment.authSuccessRedirectUrl,
        });
      },
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientDetailsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SatHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
